import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { QueryState } from '@/components/feedback/query-state';
import { SkeletonSheet } from '@/components/feedback/skeletons';
import {
  IssueAmount,
  IssueBody,
  IssueMeta,
  IssueStatusRow,
  productLabel,
} from '@/components/issues/issue-work';
import { PageHeader } from '@/components/page-header';
import { adminQuery } from '@/lib/query';

export const Route = createFileRoute('/_app/issues/$issueId')({
  component: IssuePage,
});

/** One report: what the customer sent, its history, and the work on it. */
function IssuePage() {
  const { issueId } = Route.useParams();
  const issue = useQuery(adminQuery('issues.get', { issue_id: issueId }));
  return (
    <QueryState query={issue} label="this report" skeleton={<SkeletonSheet />}>
      {(report) => (
        <div className="flex max-w-3xl flex-col gap-6">
          <PageHeader
            title={`${productLabel(report.product)} issue`}
            actions={
              <>
                <IssueAmount report={report} />
                <IssueStatusRow report={report} />
              </>
            }
          />
          <p className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-muted-foreground">
            <IssueMeta report={report} />
          </p>
          <IssueBody report={report} />
        </div>
      )}
    </QueryState>
  );
}
